import { render, staticRenderFns } from "./VueStars.vue?vue&type=template&id=660648e8&"
import script from "./VueStars.vue?vue&type=script&lang=js&"
export * from "./VueStars.vue?vue&type=script&lang=js&"
import style0 from "./VueStars.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports